module.exports = __webpack_public_path__ + "static/media/delete-blue.983ea6be.svg";